import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView, trackVisit } from '../utils/analytics';

function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(path);
    trackVisit(path).catch((error) => {
      console.error('Failed to track visit:', error);
    });
  }, [location]);

  return null;
}

export default RouteAnalytics;
